import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const ExternalSearchConfirmationModal = ({ getCompanyExternalInformation, t, closeExternalSearchConfirmationModal }) => {
  return (
    <Dialog
      open={true}
      aria-labelledby='externalSearch-dialog-title'
      maxWidth='xs'
      fullWidth
      disableEscapeKeyDown
      title={t('OfferEdit.Client.PJ.ExternalSearch.Title')}
      onClose={closeExternalSearchConfirmationModal}
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'offerPartnerCard_externalSearchConfirmationModal_Accept'} onClick={getCompanyExternalInformation} fullWidth>
            {t('OfferEdit.Client.PJ.ExternalSearch.Accept')}
          </Button>
          <Button id={'offerPartnerCard_externalSearchConfirmationModal_Reject'} onClick={closeExternalSearchConfirmationModal} fullWidth>
            {t('OfferEdit.Client.PJ.ExternalSearch.Reject')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

ExternalSearchConfirmationModal.propTypes = {
  getCompanyExternalInformation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  closeExternalSearchConfirmationModal: PropTypes.func.isRequired
};

export default withTranslation()(ExternalSearchConfirmationModal);
